import { createGlobalStyle } from "styled-components";
import * as fontsCSS from "./global-style-fonts-APP_CLIENT.css";
import isPropValid from "@emotion/is-prop-valid";
import type { KnownTarget } from "styled-components/dist/types";

export const GlobalStyle = createGlobalStyle`
  ${fontsCSS}
`;

export function shouldForwardProp(
  propName: string,
  target: string | KnownTarget
): boolean {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
}
